import Modal from '~/js/components/global/Modal';
import Slider from 'react-slick';
import SliderArrow from '~/js/components/accommodations/SliderArrow';

import Promotions from '~/js/components/specials/specials-by-resort/PageContent/Promotions';
import MinimumRates from '~/js/components/specials/specials-by-resort/PageContent/MinimumRates.js';

const { Component } = React;
const internals = {};

internals.resortDescription = {
  'BBO': {
    title: 'All New!',
    description: 'entirely redesigned'
  },
  'BNG': {
    title: '#1 Resort',
    description: 'for families in the caribbean'
  },
  'BTC': {
    title: 'Best Value!',
    description: 'beaches best value resort'
  }
};

export default class PageContent extends Component {
    static defaultProps = {
      minimumRates: {},
      percentageOff: [],
      promotions: [],
      resortsSummary: {},
      resortsSlider: {}
    }

    constructor(props) {
      super(props);

      this.state = {
        promotionTitle: '',
        promotionDetails: ''
      };
    }


    getResorts() {

      return this.props.resorts.map(rstCode => {
        const resortSummary = this.props.resortsSummary[rstCode];
        const isDesktop = window.innerWidth >= 1024;
        let lastMinuteDealsResort = this.props.lastMinuteDeals[rstCode];
        let rstURL = resortSummary.resortShortName.replace('Beaches ', '');
        
        rstURL = rstURL.replace(/(\s&\s)|\s/g, '-').toLowerCase();

        return (
          <div className="content-resort active" key={rstCode}>
            <div className="container">
              {!isDesktop && this.getResortCard(rstCode, rstURL, resortSummary,lastMinuteDealsResort)}
              {isDesktop && this.getResortCardDesktop(rstCode, rstURL, resortSummary,lastMinuteDealsResort)}
            </div>
          </div>
        );
      });
    }
 
    
    getResortCard = (rstCode, rstURL, resortSummary,lastMinuteDealsResort) => {
      return (<div className="layout">
        {this.getResortImg(rstCode, rstURL, 'resort-img txt-center')}
        <div className="resort-info">
          {this.getResortLocation(resortSummary)}
          <div className="slider">
            {this.getResortImg(rstCode, rstURL, 'hidden-large-up')}
          </div>
          <Promotions promotions={this.props.promotions[rstCode]} rstcode={rstCode} countdown={this.props.countdown} viewPromotionDetails={this.viewPromotionDetails} lastMinuteDeals={lastMinuteDealsResort}/>
        </div>
        <MinimumRates minimumRates={this.props.minimumRates[rstCode]} accomodationsURL={'/resorts/' + rstURL + '/rooms'} rstCode={rstCode} promotions={this.props.promotions[rstCode]}/>
      </div>);
    }

    getResortCardDesktop = (rstCode, rstURL, resortSummary,lastMinuteDealsResort) => {
      return (<div className="layout">
        {this.getResortImg(rstCode, rstURL, 'resort-img txt-center')}
        <div className="resort-info">
          <div>
            <div className="location-promos">
              {this.getResortLocation(resortSummary)}
              <Promotions promotions={this.props.promotions[rstCode]} rstcode={rstCode} countdown={this.props.countdown} viewPromotionDetails={this.viewPromotionDetails} lastMinuteDeals={lastMinuteDealsResort} />
            </div>
          </div>
          <MinimumRates minimumRates={this.props.minimumRates[rstCode]} accomodationsURL={'/resorts/' + rstURL + '/rooms'} rstCode={rstCode} viewPromotionDetails={this.viewPromotionDetails} promotions={this.props.promotions[rstCode]} />
        </div>
      </div>);
    }

    getResortLocation = (resortSummary) => {
      const rstName = resortSummary.resortShortName.replace('Beaches ', '');

      return (<div className="content-resort-logo">
        <h3>Beaches {rstName}</h3>
        <p>{resortSummary.resortCity}, {resortSummary.resortCountry}</p>
      </div>);
    }

    getRackRates = (rstCode, rstURL) => {
      return (<div className="rack-rates-container">
        <div className="rack-rates">
          <p className="up-to">Get UP to</p>
          <p className="percentage">{this.props.percentageOff.find(resort => resort.resortCode === rstCode).amount}</p>
          <p className="off-rack">Off Rack Rates</p>
        </div>
        <div className="links-container">
          <a className="btn-resort-details" href={`/resorts/${rstURL}/`}>Learn more about this resort</a>
          <a className="btn-resort-details" href="/compare/">Compare to another Beaches</a>
          {/* <a className="btn-resort-details" href={`/testimonials/?rst_code=${rstCode.toLowerCase()}`}>View testimonials</a> */}
          <a className="btn-resort-details" href={`/resorts/${rstURL}/videos`}>View resort videos</a>
        </div>
      </div>);
    }

    getResortImg = (rstCode, imgRstName, classes) => {
      const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        arrows: true,
        nextArrow: <SliderArrow classNames="slider-arrow slider-arrow-next" />,
        prevArrow: <SliderArrow classNames="slider-arrow slider-arrow-prev" />
      };
      const resortNumberImages = {
        'btc': 16,
        'bng': 17,
        'bbo': 21
      };

      const totalNumber = resortNumberImages[String(rstCode.toLowerCase())];
      let i = 1;
      const images = [];

      while (i <= totalNumber) {
        images.push(<img src={`${this.props.cdnURL}/resorts/all-resorts-sliders/${rstCode.toLowerCase()}/${i}.jpg`} alt={`${rstCode} Slider Image`} />);
        i++;
      }

      return (
        <div className={`resort-desc ${classes}`}>
          <Slider {...settings}>
            {
              images.map((image, index) => {
                return <img key={index} src={image.props.src} alt={image.props.alt} />;
              })
            }
          </Slider>
          <h5>{internals.resortDescription[rstCode].title}</h5>
          <p>{internals.resortDescription[rstCode].description}</p>
        </div>
      );
    }

    viewPromotionDetails = (promotionDetails, promotionTitle) => {
      this.setState({ promotionDetails, promotionTitle });
    }

    render() {
      const { promotionTitle, promotionDetails } = this.state;

      return (
        <div className="page-content">
          {this.getResorts()}
          <Modal id="promotionsModal" title={promotionTitle} content={promotionDetails} />
        </div>
      );
    }
}
